// @ts-check

/**
 * Helper class detecting current device and browser.
 * @module detectors/UserAgentHelper
 */

/** The current user agent. */
const ua = window.navigator.userAgent;

/** Detects if browser is run on iOS device.
 *
 * @returns {boolean} True if the user agent contains iPod|iPhone|iPad
 */
export function isIos() {
    return /(iPod|iPhone|iPad)/i.test(ua);
}

/** Detects if browser is run on iPadOS device or older iPad.
 *
 * @returns {boolean} True if the user agent contains iPad or is a "Mac" with touch points, ie iPadOS.
 */
export function isIpad() {
    const isIpad = ua.toLowerCase().indexOf('ipad') !== -1;

    if (!isIpad && ua.match(/Mac/) && navigator.maxTouchPoints && navigator.maxTouchPoints > 2) {
        return true;
    }

    return isIpad;
}

/**
 * Detects if the user's device is a mobile device and not a 'computer'
 * @returns {boolean} True if the user agent contains a mobile value
 */
export function isMobile() {
    return !!/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(ua);
}

/**
 * Detects if the user's device is a chromebook
 * @returns {boolean} True if the user agent contains CrOS
 */
export function isChromeBook() {
    return !!ua.match(/(CrOS)/g);
}

/**
 * Detects if the user's browser is IE10 or greater
 @returns {boolean} True if the user agent is IE10 or greater
 */
export function isIE() {
    return document.body.style.msTouchAction !== undefined;
}

/**
 * Detects if the user's browser is Edge
 @returns {boolean} True if the user agent is Edge
 */
export function isEdge() {
    return ua.indexOf('Edge') > -1;
}